/**
 * Trace Service
 *
 * Captures and stores structured events for a single user request lifecycle.
 * This allows us to build a complete picture of a request's journey through the system.
 */

export interface TraceEvent {
  id: string;
  timestamp: number;
  traceId: string;
  type: string; // e.g., 'llm_request', 'tool_call', 'crdt_update'
  data: any;
  metadata?: any;
}

class TraceService {
  private events: TraceEvent[] = [];
  private listeners: ((events: TraceEvent[]) => void)[] = [];

  log(event: Omit<TraceEvent, 'id' | 'timestamp'>) {
    const newEvent: TraceEvent = {
      ...event,
      id: `evt_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
      timestamp: Date.now(),
    };
    this.events.push(newEvent);
    this.notifyListeners();
  }

  getEvents(): TraceEvent[] {
    return [...this.events];
  }

  clear() {
    this.events = [];
    this.notifyListeners();
  }

  subscribe(callback: (events: TraceEvent[]) => void): () => void {
    this.listeners.push(callback);
    return () => {
      const index = this.listeners.indexOf(callback);
      if (index > -1) {
        this.listeners.splice(index, 1);
      }
    };
  }

  private notifyListeners() {
    this.listeners.forEach(callback => {
      try {
        callback([...this.events]);
      } catch (error) {
        console.error('[TraceService] Error in listener callback:', error);
      }
    });
  }
}

export const traceService = new TraceService();


